export const defaultAppRatingsServicesTitle = "NissanConnect Services";
export const allAppRatingsServicesTitle = "NissanConnect Services";
export const europeAppRatingsServicesTitle = "NissanConnect Services";
export const g8Markets = ["Norway", "Italy", "United Kingdom", "Netherlands", "Spain", "Belgium", "Germany", "France"];
export const g5Markets = ["United Kingdom", "Germany", "France", "Spain", "Italy"];
